// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  IChangeRequest,
  useAddMenu,
  useApproveChangeRequest,
  useGetAllMenuList,
  useGetMenuTypeSettingsList,
  useUpdateMenu,
} from "../../../hooks";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  BaseModal,
  BaseModalProps,
  InputControl,
  RadioButtonsControl,
  SelectControl,
  SwitchControl,
  TransactionModal,
} from "../../molecules";
import { Button, Loading } from "../../atoms";
import { useForm } from "react-hook-form";
import React, { useEffect, useMemo } from "react";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  menuAddProfileFormSchema,
  MenuApprovalFormSchemaFormValuesType,
  menuAddProfileInitialValues,
  menuApprovalFormSchema,
  menuApprovalInitialValues,
} from "./_formTypes";
import { useUserInfo } from "../../../store/User.state";
import translations from "../../../common/transactionKey.json";
import screenConfigurations from '../../../common/screenConfigurations';

export type TransactionApprovalModalProps = BaseModalProps & {
  title?: string;
  menu?: IChangeRequest;
};

export const TransactionApprovalModal = ({
  onClose,
  menu,
  isOpen,
  title = "Değşiklikleri Onayla",
}: TransactionApprovalModalProps) => {
  const { control, reset, handleSubmit } =
    useForm<MenuApprovalFormSchemaFormValuesType>({
      resolver: zodResolver(menuApprovalFormSchema),
      defaultValues: menuApprovalInitialValues,
    });
  const { mutate: approveTransaction, isLoading } = useApproveChangeRequest();
  const setSnackbar = useSetSnackBar();
  const [userInfo] = useUserInfo();
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [actionType, setActionType] = React.useState<
    "approve" | "reject" | null
  >(null);
  const [reason, setReason] = React.useState("");

  const handleOpenConfirmDialog = (type: "approve" | "reject") => {
    setActionType(type);
    setConfirmDialogOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setActionType(null);
    setConfirmDialogOpen(false);
  };

  const handleConfirm = () => {
    if (actionType === "reject" && !reason.trim()) {
      setSnackbar({
        severity: "error",
        isOpen: true,
        description: "Reddetme gerekçesini boş bırakamazsınız!",
      });
      return;
    }

    if (actionType === "approve") {
      handleApproval(true);
    } else if (actionType === "reject") {
      handleApproval(false, reason);
    }
    setReason("");  // gerekçeyi sıfırla
    handleCloseConfirmDialog();
  };




  useEffect(() => {
    if (!!menu && JSON.stringify(menu) !== "{}") {
      reset({
        name: menu.name,
        parentId: `${menu.parentId}`,
        order: `${menu.order}`,
        description: menu.description,
        url: menu.url,
        feType: menu.feType,
        menuType: `${menu.menuType}`,
        exactMatch: menu.exactMatch,
        media: menu.media,
        feId: menu.feId,
        menuCode: menu.menuCode,
      });
    }
  }, [reset, menu]);
  function parseJsonData(jsonStr) {
    try {
      return JSON.parse(jsonStr);
    } catch (e) {
      console.error("Failed to parse JSON:", e);
      return {};
    }
  }


  const oldValues = parseJsonData(menu?.entityOldValue || "{}");
  const newValues = parseJsonData(menu?.entityNewValue || "{}");
  const handleApproval = (approve: boolean, rejectionReason: string = "") => {
    const request: IChangeRequestApprove = {
      id: +menu.id,
      type: menu.type,
      approve: approve,
      userId: +userInfo.userId,
      rejectReason: rejectionReason,
    };

    approveTransaction(request, {
      onSuccess(data) {
        if (data.isSuccess) {
          onClose();
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          onClose();
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: data.message,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          isOpen: true,
          description: "İşlem sırasında bir hata oluştu",
        });
      },
    });
  };

  const RenderTableHeaders = ({ operationMode }) => {
    switch (operationMode) {
      case "UPDATE":
        return (
          <TableRow >
            <TableCell sx={{ color: "white" }}>Alan</TableCell>
            <TableCell sx={{ color: "white" }}>Eski Değer</TableCell>
            <TableCell sx={{ color: "white" }}>Yeni Değer</TableCell>
          </TableRow>
        );
      case "ADD":
        return (
          <TableRow>
            <TableCell sx={{ color: "white" }}>Alan</TableCell>
            <TableCell sx={{ color: "white" }} colSpan={2}>
              Eklenecek Değer
            </TableCell>
          </TableRow>
        );
      case "DELETE":
        return (
          <TableRow>
            <TableCell sx={{ color: "white" }}>Alan</TableCell>
            <TableCell sx={{ color: "white" }} colSpan={2}>
              Silinecek Değer
            </TableCell>
          </TableRow>
        );
      case "SendMoney":
        return (
          <TableRow>
            <TableCell sx={{ color: "white" }}>Alan</TableCell>
            <TableCell sx={{ color: "white" }} colSpan={2}>
              Eklenecek Değer
            </TableCell>
          </TableRow>
        );
        break;
      default:
        return null;
    }
  };


  const RenderTableRows = ({ operationMode, oldValues, newValues, operationCode }) => {
    const config = screenConfigurations[operationCode] || {};
    const { translations = {}, order = [], hideFields = [] } = config;
    debugger;
    const fieldsToDisplay = Object.keys(operationMode === "ADD" ? newValues : (operationMode === "SendMoney" ? newValues[0] : oldValues))
      .filter(key => !hideFields.includes(key))
      .sort((a, b) => order.indexOf(a) - order.indexOf(b))
      .map(key => ({
        key: key,
        translatedKey: translations[key] || key,
        oldValue: oldValues[key],
        newValue: (operationMode === "SendMoney" ? newValues[0][key] : newValues[key])
      }));

    return fieldsToDisplay.map(({ key, translatedKey, oldValue, newValue }) => {
      // Boolean değerler için Türkçe metin dönüşümü
      debugger;
      const displayOldValue = typeof oldValue === 'boolean' ? (oldValue ? "Evet" : "Hayır") : oldValue;
      const displayNewValue = typeof newValue === 'boolean' ? (newValue ? "Evet" : "Hayır") : newValue;

      const isValueChanged = displayOldValue !== displayNewValue;

      switch (operationMode) {
        case "UPDATE":
          return (
            <TableRow key={key}>
              <TableCell sx={{ backgroundColor: "#5aabcd", color: "white", width: "33.3%" }}>
                {translatedKey}
              </TableCell>
              <TableCell sx={{ backgroundColor: isValueChanged ? 'yellow' : 'white', color: "black" }}>
                {displayOldValue}
              </TableCell>
              <TableCell sx={{ backgroundColor: isValueChanged ? 'yellow' : 'white', color: "black" }}>
                {displayNewValue}
              </TableCell>
            </TableRow>
          );
        case "ADD":
          return (
            <TableRow key={key}>
              <TableCell sx={{ backgroundColor: "#5aabcd", color: "white", width: "50%" }}>
                {translatedKey}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "white", color: "black" }}
                colSpan={2}
              >
                {operationMode === "ADD" ? displayNewValue : displayOldValue}
              </TableCell>
            </TableRow>
          );
        case "DELETE":
          return (
            <TableRow key={key}>
              <TableCell sx={{ backgroundColor: "#5aabcd", color: "white", width: "50%" }}>
                {translatedKey}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "white", color: "black" }}
                colSpan={2}
              >
                {operationMode === "ADD" ? displayNewValue : displayOldValue}
              </TableCell>
            </TableRow>
          );
        case "SendMoney":
          return (

            <TableRow key={key}>
              <TableCell sx={{ backgroundColor: "#5aabcd", color: "white", width: "50%" }}>
                {translatedKey}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "white", color: "black" }}
                colSpan={2}
              >
                {operationMode === "SendMoney" ? displayNewValue : displayOldValue}
              </TableCell>
            </TableRow>
          );
        default:
          return null;
      }
    });
  };



  return (
    <>
      {isLoading && <Loading />}
      <TransactionModal onClose={onClose} title={title} isOpen={isOpen}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#0C9FDC " }}>
              <RenderTableHeaders operationMode={menu?.operationMode} />
            </TableHead>
            <RenderTableRows
              operationMode={menu?.operationMode}
              oldValues={oldValues}
              newValues={newValues}
              operationCode={menu?.operationCode}
            />
          </Table>
        </TableContainer>
        {menu?.status === "PENDING" && (
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={2}
            mt={2}
            mr={2}
          >
            <Button
              variant="contained"
              text="Onayla"
              sx={{ width: 150 }}
              onClick={() => handleOpenConfirmDialog("approve")}
            >
              Onayla
            </Button>
            <Button
              variant="outlined"
              text="Reddet"
              sx={{ width: 150 }}
              onClick={() => handleOpenConfirmDialog("reject")}
            >
              Reddet
            </Button>
          </Stack>
        )}
      </TransactionModal>

      <Dialog open={confirmDialogOpen} onClose={handleCloseConfirmDialog}>
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            fontSize: 24,
            fontWeight: 600,
            gap: 6
          }}
        >
          İşlemi gerçekleştirmek istiyor musunuz?
          {actionType === "reject" && (
            <TextField
              sx={{ flex: 1, marginTop: 2, width: "100%" }}
              type="text"
              sx={{ marginTop: 2 }}
              label="Reddetme Gerekçesi"
              defaultValue=""
              value={reason}
              inputProps={{ maxLength: 40 }}
              onChange={(e) => setReason(e.target.value)}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleConfirm}
            color="primary"
            text="Evet"
            autoFocus
            variant="contained"
          >
            Evet
          </Button>
          <Button
            onClick={handleCloseConfirmDialog}
            color="primary"
            text="Hayır"
            variant="outlined"
          >
            Hayır
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
